import { useTranslation } from "react-i18next";

import { DisclosuresList } from "./DisclosuresDropdownMenu";
import Categories from "~/features/MarketIntelligence/Categories";

import { UtilityStore } from "~/stores/UtilityStore";
import { useTabStore } from "~/stores";
import { SEARCH_TABS } from "~/types/search.types";

import KeywordInput from "./KeywordInput";
import BtnPopupTrigger from "./BtnPopupTrigger";
import useKeywordSearch from "../../hooks/useKeywordSearch";
import SearchPanelMessage from "~/components/SearchPanelMessage";

const SearchBarLabel = () => {
    const { t } = useTranslation();
    const activeTab = useTabStore(state => state.tab);
    const isMarketingFromTop = UtilityStore((state: any) => state.isMarketingFromTop);
    const isKeywordTab = activeTab?.key === SEARCH_TABS.KEYWORDS;
    const { searchMsg, showMsg, handleClearMessage, ...rest } = useKeywordSearch();

    return (
        <>
            <div>
                <div className="flex items-center gap-3 min-w-[47.5rem] h-16 py-3 px-4 bg-white rounded-2xl !shadow-md !text-stone-vibrant !text-base tracking-[-0.32px] z-10">
                    <div>{t("searchForm.searchPartialMsg")}</div>

                    <div className="px-2 text-stone-darkest font-medium-light">
                        <DisclosuresList className="text-base" />
                    </div>

                    <div className="w-[1px] h-[1.875rem] bg-stone-soft"></div>

                    {isKeywordTab ? <KeywordInput {...rest} /> : <BtnPopupTrigger />}
                </div>

                <SearchPanelMessage
                    {...searchMsg}
                    show={showMsg}
                    onClearTrigger={handleClearMessage}
                />
            </div>
            {isMarketingFromTop && <Categories />}
        </>
    );
};

export default SearchBarLabel;
